import { motion } from "framer-motion";
import { ArrowRight, Download, CircleCheck } from "lucide-react";

export default function HeroBanner({
  image,
  content,
  showApply = false,
  applyUrl,
  brochure,
}) {
  return (
    <section className="relative min-h-[55vh]   flex items-center overflow-hidden">
      {/* Imagen de fondo */}
      <img
        src={image}
        alt="Portada"
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(120deg,rgba(0,66,112,0.92)_0%,rgba(0,66,112,0.70)_45%,rgba(2,6,23,0.30)_100%)]" />

      {/* Contenido */}
      <div className="relative z-10 w-full">
        <div className="mx-auto max-w-7xl px-6 py-16 lg:py-20">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mx-auto max-w-4xl text-center"
          >
            <div
              className="
                [&_h1]:mx-auto
                [&_h1]:text-white
                [&_h1]:text-4xl
                [&_h1]:lg:text-5xl
                [&_h1]:font-bold
                [&_h1]:leading-tight

                [&_h2]:mx-auto
                [&_h2]:text-white
                [&_h2]:text-3xl
                [&_h2]:lg:text-4xl
                [&_h2]:font-bold
                [&_h2]:leading-tight

                [&_p]:mx-auto
                [&_p]:mt-5
            
                [&_p]:text-lg
                [&_p]:leading-8
                [&_p]:text-slate-200
              "
              dangerouslySetInnerHTML={{
                __html: content ?? "",
              }}
            />

            {(showApply || brochure) && (
              <div className="mt-10 flex flex-wrap justify-center gap-4">
                {showApply && applyUrl && (
                  <a
                    href={applyUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex min-w-[220px] items-center justify-center gap-2 rounded-xl bg-amber-400 px-7 py-3.5 font-semibold text-[#004270] shadow-lg transition-all duration-300 hover:bg-amber-300 hover:text-[#004270] hover:shadow-xl"
                  >
                    Postular ahora
                    <ArrowRight size={18} />
                  </a>
                )}

                {brochure && (
                  <a
                    href={brochure}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex min-w-[220px] items-center justify-center gap-2 rounded-xl border border-white/30 bg-white/10 px-7 py-3.5 font-semibold text-white backdrop-blur-sm transition-all duration-300 hover:bg-white/20"
                  >
                    <Download size={18} />
                    Descargar brochure
                  </a>
                )}
              </div>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
